import { jsonMember, jsonObject } from 'typedjson';
import { SequenceSearchResultHitDataResponse } from '@api/sequence/responses/sequence-search-result-hit-data.response';

@jsonObject
export class SequenceSearchResultHitCollectionItemResponse {
  @jsonMember readonly id!: string;
  @jsonMember readonly data!: SequenceSearchResultHitDataResponse;
}
